// extracted by css-extract-rspack-plugin
var _1 = "dbOlm";
var _2 = "JxwJ6";
var _3 = "ESO13";
var _4 = "nUo8r";
var _5 = "wdqIM";
var _6 = "rnqAg";
var _7 = "JBWmn";
var _8 = "ibCzq";
var _9 = "DOWm0";
var _a = "LCQlV";
var _b = "dEHFj";
export { _1 as "firstLineTextCompact", _2 as "firstLineTextMedium", _3 as "firstLineTextRead", _4 as "firstLineTextSCLTypeRampCompact", _5 as "firstLineTextSCLTypeRampFull", _6 as "firstLineTextSCLTypeRampMedium", _7 as "firstLineTextUnread", _8 as "firstLineTextWin32", _9 as "mclFirstLineTextUnread", _a as "mclFirstLineTextUnreadTypeRamp", _b as "mclFirstLineTextUnreadTypeRampSelected" }
